



























































































import { Component, Vue } from "vue-property-decorator";

import { BaseGridComponent, GridPagerCpt } from "@/core/components";
import { WorkshopStatus } from "@/core/constants";
import { WorkshopCollectionModel, PagedCollectionFilter, WorkshopFilterModel } from "@/core/models";
import { WorkshopService } from "@/core/services";
import { WorkflowGridFiltersCpt, WorkshopStatusCpt } from "./";
import moment from "moment";

@Component({
  components: {
    GridPagerCpt,
    WorkflowGridFiltersCpt,
    WorkshopStatusCpt,
  },
})
export default class WorkshopGridCpt extends BaseGridComponent<WorkshopCollectionModel, WorkshopFilterModel> {
  filter = {} as PagedCollectionFilter & WorkshopFilterModel;

  async created() {
    this.initializeFilters();
    this.load();
  }

  private filterUpdated(filter: PagedCollectionFilter & WorkshopFilterModel) {
    this.filter = filter;
    this.filter.page = 1;
    this.load();
  }

  private load() {
    this.initialize(filter => WorkshopService.filterWorkshops(filter), "workshops", this.filter);
  }

  private initializeFilters() {
    if (this.filter) {
      const query = this.$route.query as any;
      this.filter.regionId = !!query.regionId ? parseInt(query.regionId, 10) : 0;
      this.filter.countyId = !!query.countyId ? parseInt(query.countyId, 10) : 0;
      this.filter.workshopStatusId = !!query.workshopStatusId ? parseInt(query.workshopStatusId, 10) : 0;
      this.filter.search = query.search || "";
      this.filter.startDate = query.startDate ? new Date(query.startDate) : ("" as any);
      this.filter.endDate = query.endDate ? new Date(query.endDate) : ("" as any);
      this.filter.sortBy = query.sortBy || "EventDate";
      this.filter.sortOperator = query.sortOperator || "desc";
    }
  }
}
